<template>
  <div>
    <div class="title">部门管理</div>
    <div class="container">
      <el-button type="primary" class="addbtn" @click="addrole" v-if="addroleshow">添加部门</el-button>
      <el-table :data="roleData" stripe border style="margin-top:20px">
        <el-table-column prop="deptName" label="部门名称"></el-table-column>
        <!-- <el-table-column prop="userNum" label="用户数量" align="center"></el-table-column> -->
        <el-table-column prop="address" label="操作" align="right" v-if="deleteShow">
          <template slot-scope="scope">
            <div>
              <span>
                <img
                  src="../images/delete.png"
                  @click="deleterole(scope.row)"
                  style="cursor:pointer"
                />
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="添加部门" :visible.sync="roleVisible" width="300px" :show-close="false">
      <div slot="title">
        <p>添加部门</p>
        <i class="el-icon-error" @click="addVisible = false"></i>
      </div>
      <div class="addroleline">部门名称 :</div>
      <div>
        <el-input v-model="rolename" placeholder="请输入部门名称" style="width:100%"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleVisible = false">取 消</el-button>
        <el-button type="primary" @click="addrolebtn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择权限" :visible.sync="choiceVisible" width="300px" :show-close="false">
      <div slot="title">
        <p>选择权限</p>
        <i class="el-icon-error" @click="choiceVisible = false"></i>
      </div>
      <el-tree
        :props="props"
        :data="treedata"
        node-key="id"
        show-checkbox
        ref="tree"
        @check-change="handleCheckChange"
        check-strictly="true"
        :default-checked-keys="nodekeylist"
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="choiceVisible = false">取 消</el-button>
        <el-button type="primary" @click="changerolebtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getdeptlist,
  adddept,
  deletedept
  // addlogoperate
} from "../axios/api.js";
export default {
  data() {
    return {
      editroleshow: true,
      addroleshow: false,
      deleteShow:false,
      roleVisible: false,
      rolename: "",
      rolekey: "",
      roleData: []
    };
  },
  methods: {
    //打开添加角色弹窗
    addrole() {
      this.rolename = null;
      this.roleVisible = true;
    },

    //获取角色列表
    getrole() {
      getdeptlist([]).then(res => {
        console.log(res.rows);
        this.roleData = res.rows;
        // this.roleList = res.data;
        // var arr = {};
        // for (var i in res.data) {
        //   arr[res.data[i].id] = res.data[i].name;
        // }
        // console.log(arr);
        // this.roleoption = arr;
        // this.totalpage = res.data.length;
      });
    },

    powerlist() {
      const arr = localStorage.getItem("permissionList")
      var newArr=JSON.parse(arr.replace(/\n/g,"\\n").replace(/\r/g,"\\r")).filter(i=>i.type==="B");
      for (var i in arr) {
        if (newArr[i].id== 44) {
          this.addroleshow = true;
        }
        if (newArr[i].id==47) {
          this.deleteShow = true;
        }

      }
    },

    //删除角色
    deleterole(e) {
      console.log(e);
      this.$confirm("您确定要删除该角色吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: action => {
          if (action === "confirm") {
            deletedept([e.id]).then(res => {
              if (res && res.code === 200) {
                this.$message({
                  message: "删除成功",
                  type: "success"
                });

                this.getrole();
              }
            });
          }
        }
      });
    },

    //确认添加角色
    addrolebtn() {
      if (!this.rolename) {
        this.$message({
          message: "请输入部门名称",
          type: "error"
        });
      } else {
        const params = {
          deptName: this.rolename
        };
        adddept(params).then(res => {
          if (res && res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success"
            });

            this.getrole();
            this.roleVisible = false;
            this.rolename = null;
          } else {
            console.log(res.message);
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        });
      }
    }
  },
  created() {
    this.getrole();
  this.powerlist()
  }
};
</script>

<style scoped>
.addroleline {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}
.title {
  text-align: left;
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
.container {
  padding: 24px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
  text-align: left;
  border-radius: 3px;
  margin-top: 24px;
}
</style>